import { z } from 'zod'

export const VServerStatsTimeframe = z.enum(['hour', 'day', 'week', 'month'])
export type VServerStatsTimeframe = z.infer<typeof VServerStatsTimeframe>

export const VServerStatsPoint = z.object({
  time: z.number(),
  cpu_percent: z.number().nullable().optional(),
  memory_used_mib: z.number().nullable().optional(),
  memory_max_mib: z.number().nullable().optional(),
  disk_used_mib: z.number().nullable().optional(),
  disk_max_mib: z.number().nullable().optional(),
  disk_read_kbps: z.number().nullable().optional(),
  disk_write_kbps: z.number().nullable().optional(),
  net_in_kbps: z.number().nullable().optional(),
  net_out_kbps: z.number().nullable().optional()
})
export type VServerStatsPoint = z.infer<typeof VServerStatsPoint>

export const VServerStats = z.object({
  timeframe: VServerStatsTimeframe,
  data: z.array(VServerStatsPoint)
})
export type VServerStats = z.infer<typeof VServerStats>
